const DAY = 86400000;
const ord = (n) => `${n}${n % 100 >= 10 && n % 100 <= 20 ? "th" : ({ 1: "st", 2: "nd", 3: "rd" })[n % 10] || "th"}`;
const GREG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const gregYmd = (d) => { const dt = new Date(Date.UTC(2000, 0, 1) + (d - 730120) * DAY); return [dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate()]; };

const customYmd = (f, d) => {
  const base = f.months.reduce((s, m) => s + m.days, 0);
  const every = Number(f.leap?.every) || 0, extra = Number(f.leap?.days) || 0, lm = Math.min(Number(f.leap?.month) || 0, f.months.length - 1);
  const below = (y) => (every ? Math.floor((y - 1) / every) : 0);
  const isLeap = (y) => !!(every && extra && y % every === 0);
  const start = (y) => (y - f.start_year) * base + extra * (below(y) - below(f.start_year));
  let y = f.start_year + Math.floor(d / (base + (every ? extra / every : 0)));
  while (start(y) > d) y -= 1;
  while (start(y + 1) <= d) y += 1;
  let rem = d - start(y);
  for (let m = 0; m < f.months.length; m += 1) {
    const ml = f.months[m].days + (m === lm && isLeap(y) ? extra : 0);
    if (rem < ml) return [y, m, rem + 1];
    rem -= ml;
  }
  return [y, f.months.length - 1, f.months[f.months.length - 1].days];
};

const yearText = (f, y, short) => (f.kind === "gregorian" ? (y > 0 ? `${y}` : `${1 - y} BCE`) : `${short ? "" : "Year "}${y}${f.era ? ` ${f.era}` : ""}`);

const dayText = (f, d, short) => {
  const [y, m, day] = f.kind === "gregorian" ? gregYmd(d) : customYmd(f, d);
  const name = f.months[m]?.name || GREG[m];
  if (short) return `${name} ${yearText(f, y, true)}`;
  return f.kind === "gregorian" ? `${name} ${ord(day)}, ${yearText(f, y)}` : `${ord(day)} ${name}, ${yearText(f, y, true)}`;
};

const ymdInt = (t) => {
  if (t < 10000101 || t > 99991231) return null;
  const y = Math.floor(t / 10000), m = Math.floor((t % 10000) / 100), d = t % 100;
  return m >= 1 && m <= 12 && d >= 1 && d <= 31 ? [y, m - 1, d] : null;
};

export const fmtT = (fmt, t, short = false) => {
  if (t == null || Number.isNaN(t)) return "";
  if (fmt) {
    try { return fmt.unit === "day" ? dayText(fmt, t + fmt.offset, short) : yearText(fmt, t + fmt.offset, short); } catch { return `${t}`; }
  }
  const p = ymdInt(t);
  if (p) return short ? `${GREG[p[1]]} ${p[0]}` : `${GREG[p[1]]} ${ord(p[2])}, ${p[0]}`;
  return short ? `${t}` : `Year ${t}`;
};

export const tlFormat = (timelines, tl) => {
  const seen = new Set();
  for (let t = tl; t && !seen.has(t.id); t = timelines.find((x) => x.id === t.parent_timeline_id)) {
    seen.add(t.id);
    if (t.date_format) return t.date_format;
  }
  return null;
};

export const makeTicks = (fmt, min, span, n) => {
  const max = min + span;
  if (!fmt && ymdInt(Math.floor(Math.max(min, 10000101) / 10000) * 10000 + 101) && ymdInt(Math.floor(Math.min(max, 99991231) / 10000) * 10000 + 101)) {
    const y0 = Math.ceil(min / 10000), y1 = Math.floor(max / 10000), step = Math.max(1, Math.ceil((y1 - y0 + 1) / n));
    const out = [];
    for (let y = y0; y <= y1; y += step) { const t = y * 10000 + 101; if (t >= min && t <= max) out.push({ t, label: `${y}` }); }
    if (out.length >= 2) return out;
    const months = [];
    for (let y = Math.floor(min / 10000); y <= Math.floor(max / 10000); y += 1) for (let m = 1; m <= 12; m += 1) { const t = y * 10000 + m * 100 + 1; if (t >= min && t <= max) months.push({ t, label: `${GREG[m - 1].slice(0, 3)} ${y}` }); }
    const ms = Math.max(1, Math.ceil(months.length / n));
    if (months.length) return months.filter((_, i) => i % ms === 0);
  }
  const out = [];
  Array.from({ length: n + 1 }, (_, i) => Math.round(min + (span * i) / n)).forEach((t) => {
    const label = fmtT(fmt, t, true);
    if (!out.length || out[out.length - 1].label !== label) out.push({ t, label });
  });
  return out;
};
